// extracted by mini-css-extract-plugin
export default {"wrapper":"YKz6N9ZNHnaT9Xg0jOC1","titleContainer":"t6zRLUPEi8JqakkapuOX"};